import type { ServicesSection } from '@/data/types';
import { resolveImagePath } from '@/utils/imageResolver';

interface ServicesProps {
  data: ServicesSection;
}

export function Services({ data }: ServicesProps) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {data.title && (
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            {data.title}
          </h2>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {data.services.map((service) => (
            <div
              key={service.id}
              className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              {/* Service Image */}
              {service.image && (
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={resolveImagePath(service.image)}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
              
              {/* Service Content */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <a
                  href={service.buttonUrl}
                  className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200"
                >
                  {service.buttonText}
                  <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}